import {useMutation} from '@tanstack/react-query'
import {useGetOrderApiMethod} from 'api/useGetOrderApiMethod'
import {usePatchBookingApiMethod} from 'api/usePatchBookingApiMethod'
import {Ventrata} from 'types'

type Params = {
  optionalOrderId?: string
  bookingUuid: string
  optionId?: string
  productId?: string
  availabilityId?: string
  unitItems: Ventrata.RequestUnitItem[]
}

export const usePatchBookingMutation = () => {
  const getOrder = useGetOrderApiMethod()
  const patchBooking = usePatchBookingApiMethod()

  return useMutation({
    mutationFn: async ({optionalOrderId, bookingUuid, availabilityId, optionId, productId, unitItems}: Params) => {
      if (!optionalOrderId) {
        throw new Error('Order id is not defined')
      }

      await patchBooking({
        bookingUuid,
        availabilityId,
        optionId,
        productId,
        unitItems,
      })
      return await getOrder(optionalOrderId)
    },
  })
}
